export const WWW_FORM_URLENCODED = 'application/x-www-form-urlencoded';
export const MULTIPART_FORM_DATA = 'multipart/form-data';
export const APPLICATION_JSON = 'application/json';
export const OCTET_STREAM = 'application/octet-stream';

export const CONTENT_TYPE = 'Content-Type';
